import React, { useEffect } from 'react';
const PIXEL_ID = '26302402029436087';
declare global {
  interface Window {
    fbq?: ((...args: unknown[]) => void) & {
      callMethod?: (...args: unknown[]) => void;
      queue?: unknown[];
      push?: unknown;
      loaded?: boolean;
      version?: string;
    };
    _fbq?: unknown;
  }
}
export function MetaPixel() {
  useEffect(() => {
    if (window.fbq) {
      window.fbq('track', 'PageView');
      return;
    }
    const fbq: Window['fbq'] = function (...args: unknown[]) {
      if (fbq!.callMethod) {
        fbq!.callMethod.apply(fbq, args);
      } else {
        fbq!.queue!.push(args);
      }
    };
    window.fbq = fbq;
    window._fbq = fbq;
    fbq.push = fbq;
    fbq.loaded = true;
    fbq.version = '2.0';
    fbq.queue = [];
    const script = document.createElement('script');
    script.async = true;
    script.src = 'https://connect.facebook.net/en_US/fbevents.js';
    document.head.appendChild(script);
    fbq('init', PIXEL_ID);
    fbq('track', 'PageView');
  }, []);
  return <noscript data-id="element-104" data-mp="18g088pk1kee0">
      <img height="1" width="1" style={{
      display: 'none'
    }} alt="" src={`https://www.facebook.com/tr?id=${PIXEL_ID}&ev=PageView&noscript=1`} data-id="element-105" data-mp="18hl54lttw9f1" />
    </noscript>;
}